import {Controller} from "@hotwired/stimulus";
import type {Chart, ChartConfiguration} from "chart.js";

export default class extends Controller {
    static override targets = ["canvas"];
    static override values = {
        config: Object
    }

    declare readonly canvasTarget: HTMLCanvasElement;
    declare readonly configValue: ChartConfiguration;

    private chart?: Chart;
    // Bumped on every connect and disconnect. A draw whose generation has gone stale by the time the
    // chart library arrives does nothing, so only the latest connect puts a chart on the canvas.
    private generation = 0;

    override connect() {
        void this.drawChart(++this.generation);
    }

    override disconnect() {
        this.generation++;
        this.chart?.destroy();
        this.chart = undefined;
    }

    // Chart.js is a separate chunk, so the page only downloads it when it shows a chart.
    private async drawChart(generation: number) {
        let ChartConstructor: typeof Chart;
        try {
            ChartConstructor = (await import("chart.js/auto")).default;
        } catch (error) {
            console.error(error);
            return;
        }

        if(generation !== this.generation) return;

        const ctx = this.canvasTarget.getContext("2d");
        if(!ctx) return;

        this.chart = new ChartConstructor(ctx, this.configValue);
    }
}
